// extracted by mini-css-extract-plugin
module.exports = {"PRODUCT_MAPPER":"ProductMapper_PRODUCT_MAPPER__2Q3Wo"};